import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarRead } from "./solar-read-retry"
import type { SolarDesignerBundleDto } from "../dto/solar-proposal-designer.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * Everything the V2 designer hydrates its own RecoilRoot from. Read once per
 * visit: a save answers with the new version, and a reload re-hydrates from a
 * fresh read rather than a background refetch replacing the editor's state.
 */
export default function useSolarProposalDesigner(
  proposalId: string,
): UseQueryResult<SolarDesignerBundleDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.designer(proposalId),
    queryFn: () => solarProposalService.getDesigner(proposalId),
    enabled: Boolean(proposalId),
    refetchOnMount: `always`,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: retrySolarRead,
  })
}
